export enum AcaoTagsNFeEntradaEnum {
  Incluir = 1,
  Remover = 2,
}
